import { Opener as InPageNavigation } from '@portals/core/src/components/InPageNavigation/index';
import { TrackingContext } from '@portals/tracking/src/context/tracking';
import React, { useCallback } from 'react';

import { ContentInPageNavigationOpener as InPageNavigationOpenerModel } from '../../../models';

export interface InPageNavigationOpenerProps {
  node: InPageNavigationOpenerModel;
}

export const InPageNavigationOpener: React.FC<InPageNavigationOpenerProps> = ({
  node,
}: InPageNavigationOpenerProps) => {
  const trackingContext = React.useContext(TrackingContext);

  const handleLinkClick = useCallback(
    (event) => {
      if (!event?.target?.href) {
        return;
      }
      trackingContext?.trackLink?.({
        linkHref: event.target.href,
        linkText: event.target.href.text,
        linkType: 'LinkAnchorLink',
      });
    },
    [trackingContext]
  );
  return (
    <InPageNavigation
      title={node.title}
      links={node.links.map((link) => ({
        text: link.text,
        anchor: link.anchor,
      }))}
      onLinkClick={handleLinkClick}
      variant={node.variant}
    />
  );
};
